import PropTypes from "prop-types"
import { useSelector } from 'react-redux'

import ReadNowButton from '@/components/PDP/ReadNowButton'
import ReduxProvider from '@/components/ReduxProvider'
require('./index.scss')

import ActionButton from './ActionButton'
import Loader from './Loader'

const className = [
  'vst-btn--large-full-width',
  'vst-btn--orange',
  'vst-btn--read-now',
  'mt-2'
].join(' ')

const VariantActions = ({ translations }) => {
  const isFree = useSelector(state => state.asset.isFree)
  const isShowing = isFree !== undefined

  return (
    <Choose>
      <When condition={isShowing}>
        <Choose>
          <When condition={isFree}>
            <div className='d-flex justify-content-center'>
              <ReadNowButton className={className} />
            </div>
          </When>
          <Otherwise>
            <ActionButton translations={translations} />
          </Otherwise>
        </Choose>
      </When>
      <Otherwise>
        <Loader />
      </Otherwise>
    </Choose>
  )
}

VariantActions.propTypes = {
  translations: PropTypes.shape({
    decrease_button: PropTypes.string,
    increase_button: PropTypes.string,
    quantity_label: PropTypes.string
  }).isRequired
}

/*eslint-disable react/no-multi-comp*/
const Component = ({ translations }) => (
  <ReduxProvider>
    <VariantActions translations={translations} />
  </ReduxProvider>
)

export default Component

Component.propTypes = {
  translations: PropTypes.shape({
    decrease_button: PropTypes.string,
    increase_button: PropTypes.string,
    quantity_label: PropTypes.string
  }).isRequired
}
